import { Client } from "creso-core/types";
import { useMemo } from "react";
import { useRouter } from "@tanstack/react-router";
import { Button } from "web-design-system";
import {
  clientStatusContentClassName,
  ClientStatusLayout,
  ClientStatusMemberDisplay,
} from "./client-status-layout";

export function LeadClientStatus({
  client,
  memberDisplay,
}: {
  client: Client;
  memberDisplay?: ClientStatusMemberDisplay;
}) {
  const statusLabel = useMemo(() => {
    if (client.kyc_status === "U") return null;
    if (client.kyc_status === "F") return "KYC not verified";
    if (client.kyc_status_remark === "KYC Validated") return "KYC Verified";
    if (client.kyc_status_remark === "KYC REGISTERED") return "KYC Registered";
    return null;
  }, [client]);

  const statusDescription = useMemo(() => {
    // if (client.kyc_status === "U" || client.kyc_status === "S")
    //   return `${client.name} needs to give consent to create an investment account.`;
    // return `${client.name} needs to consent to account creation and complete KYC.`;
    return "Create client account to start investment journey.";
  }, []);

  // const { mutateAsync: createInvestmentAccount } = useCreateInvestmentAccount();
  const router = useRouter();
  const handleResendLink = async () => {
    router.navigate({
      to: ".",
      search: {
        modal: "client-lead",
        client_id: client.id,
        action: "create-account",
      },
    });
  };

  return (
    <ClientStatusLayout memberDisplay={memberDisplay}>
      <div
        className={clientStatusContentClassName(
          memberDisplay,
          "justify-between"
        )}
      >
        <span className="text-sm mr-auto">
          {statusLabel ? (
            <span className="font-semibold">{statusLabel}&nbsp;&nbsp;</span>
          ) : null}
          {statusDescription}
        </span>
        <Button variant="default" onClick={handleResendLink}>
          Create Account
        </Button>
      </div>
    </ClientStatusLayout>
  );
}
